import { render, staticRenderFns } from "./StyleSelectControl.vue?vue&type=template&id=08982055&scoped=true&"
import script from "./StyleSelectControl.vue?vue&type=script&lang=js&"
export * from "./StyleSelectControl.vue?vue&type=script&lang=js&"
import style0 from "./StyleSelectControl.vue?vue&type=style&index=0&id=08982055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08982055",
  null
  
)

export default component.exports